import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { Typography } from "@mui/material";

function valuetext(value) {
  return { value };
}

export default function RangeSlider({ value, onChange = () => {}, flex, labelFlex, ...props }) {
  return (
    <Box display="flex" alignItems="center" width="100%" mt={{ xs: 4, sm: 0, md: 0 }}>
      <Slider
        getAriaLabel={() => "height range"}
        {...props}
        value={value}
        onChange={onChange}
        valueLabelDisplay="on"
        getAriaValueText={valuetext}
        min={130}
        max={200}
        sx={{
          color: "#FB83AC",
          flex,
          "&:disabled , &.Mui-disabled": {
            color: "#FB83AC",
          },
          "& .MuiSlider-track": {
            border: "none",
            height: 6,
          },
          "& .MuiSlider-rail": {
            opacity: 1,
            backgroundColor: "#EEEEEE",
            height: 6,
            borderRadius: 60,
          },
          "& .MuiSlider-thumb": {
            height: 22,
            width: 22,
            backgroundColor: "#FFFFFF",
            border: "4px solid currentColor",
            boxShadow: "0 2px 5px 1px #aaa",
            paddingTop: 0,
          },
          "& .MuiSlider-valueLabel": {
            lineHeight: "20px",
            fontSize: "14px",
            background: "unset",
            letterSpacing: "-0.28px",
            padding: 0,
            paddingTop: "0.1rem",
            width: 32,
            height: 32,
            color: "#4C466F",
          },
        }}
        aria-label="Volume"
      />
      <Typography
        variant="h2"
        ml={3}
        sx={{
          flex: labelFlex,
        }}
      >
        قد
      </Typography>
    </Box>
  );
}
